import React from 'react';
import { Tilt } from 'react-tilt';
import { motion } from 'framer-motion';

export default function ServiceCard({ icon: Icon, title, description, index = 0, onClick }) {
  return (
    <Tilt
      options={{
        max: 15,
        scale: 1.02,
        speed: 400,
        glare: true,
        'max-glare': 0.2,
      }}
      className="h-full"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: index * 0.1 }}
        viewport={{ once: true }}
        onClick={onClick}
        data-testid={`service-card-${index}`}
        className="group h-full p-6 md:p-8 rounded-2xl glass border border-[var(--border-subtle)] hover:border-[var(--border-highlight)] transition-all duration-500 cursor-pointer"
        style={{
          background: 'linear-gradient(145deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 100%)',
        }}
      >
        {/* Icon Container */}
        <div className="mb-6 relative">
          <div className="w-14 h-14 rounded-xl bg-[var(--primary-main)] bg-opacity-10 flex items-center justify-center group-hover:bg-opacity-20 transition-all duration-300">
            <Icon className="w-7 h-7 text-[var(--primary-light)] group-hover:text-[var(--accent-gold)] transition-colors duration-300" />
          </div>
          {/* Glow effect on hover */}
          <div className="absolute inset-0 w-14 h-14 rounded-xl bg-[var(--primary-main)] opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-500" />
        </div>

        {/* Title */}
        <h3 className="text-lg md:text-xl font-bold mb-3 text-[var(--text-primary)] group-hover:text-[var(--accent-gold)] transition-colors duration-300">
          {title}
        </h3>

        {/* Description */}
        <p className="text-sm md:text-base text-[var(--text-secondary)] leading-relaxed">
          {description}
        </p>

        {/* Bottom accent line */}
        <div className="mt-6 h-0.5 w-0 group-hover:w-full bg-gradient-to-r from-[var(--primary-main)] to-[var(--accent-gold)] transition-all duration-500 rounded-full" />
      </motion.div>
    </Tilt>
  );
}
